import { Text } from '@pm/ui';
import { isValid } from 'date-fns';
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { EncounterDetail } from './EncounterDetail';

type AppointmentDateProps = {
  date: Date;
  timeZone?: string;
  size?: ComponentProps<typeof Text>['size'];
  withIcon?: boolean;
};

export const AppointmentDate = ({
  date,
  timeZone,
  size = 'headingXS',
  // Temporary while we still have the existing UI when booking a new appointment
  // Remove this when https://github.com/purposemed/core/issues/12048 is done.
  withIcon = false,
}: AppointmentDateProps) => {
  const { t } = useTranslation('appointments', {
    keyPrefix: 'Appointment.Summary',
  });

  const iconName = withIcon ? 'calendar_today' : undefined;

  if (!isValid(date)) {
    return null;
  }

  const appointmentDate = t('AppointmentDate', {
    date,
    formatParams: { date: { timeZone } },
  });

  return (
    <EncounterDetail iconName={iconName}>
      <Text
        size={size}
        as="time"
        role="time"
        dateTime={isoCalendarDate(date, timeZone)}
        title={appointmentDate}
      >
        {appointmentDate}
      </Text>
    </EncounterDetail>
  );
};

const isoCalendarDate = (date: Date, timeZone?: string) =>
  new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
